import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    componentReaction,
    IMultiSelectOption,
    InfiniteScroll,
    inject,
    mobxEqual,
    Modal,
    ModalHandle,
    TasksStore,
} from 'Mri.Web.Common';
import { stringify } from 'qs';
import * as React from 'react';
import { BsArrowRepeat } from '@react-icons/all-files/bs/BsArrowRepeat';
import { BsTv } from '@react-icons/all-files/bs/BsTv';
import { AppStore } from '../Core/AppStore';
import { DisplayFiltersStore } from '../DisplayFilters/DisplayFiltersStore';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';
import { DisplayHeader } from '../Displays/DisplayHeader';
import { DisplayRow } from '../Displays/DisplayRow';
import { DisplaysStore } from '../Displays/DisplaysStore';
import {IWhereClause} from "../DisplayFilters/WhereFilter";

export interface IDisplayListModalProps {
    readonly modalHandle: ModalHandle;
    readonly displayEventFilter?: Mri.DisplayEvents.DisplayEventFilter;
    readonly displayFilter: Mri.Web.Portal.Controllers.DisplayFilters.DisplayFilterModel;
    readonly where?: string;
    readonly title: React.ReactNode;
    readonly accounts?: string[];
    readonly history: any;
}

@autoinject
@observer
export class DisplayListModal extends React.Component<IDisplayListModalProps> {
    public constructor(props: IDisplayListModalProps) {
        super(props);

        this.vm = new DisplayListViewModel({
            onChange: this.onChange,
            onClear: this.onClear,
            displayFilter: props.displayFilter,
            displayEventFilter: props.displayEventFilter,
            sort: ['StatusRank desc'],
            columns: [{ option: 'Serial Number' }, { option: 'Description' }, { option: 'Status' }],
        });

        this.listView = !this.appStore.isMobile;

        componentReaction(
            this,
            () => this.props.displayFilter,
            f => (this.vm.displayFilter = f)
        );

        componentReaction(
            this,
            () => this.props.displayEventFilter,
            f => (this.vm.displayEventFilter = f)
        );

        componentReaction(
            this,
            () => this.props.where,
            w => {
                if (w) {
                    this.vm.where = [
                        {
                            option: 'Custom',
                            value: w,
                        },
                    ];
                } else {
                    this.vm.where = [];
                }
            }
        );
    }

    public render() {
        const { hasMore, busy, loadMoreAsync, displays } = this.vm;

        return (
            <Modal
                title={this.renderTitle()}
                modalHandle={this.props.modalHandle}
                bodyClass="p-0 display-list-view-modal"
                footerClass="d-none"
                size="xl"
                bodyRef={action((r: HTMLDivElement | null) => (this.container = r))}
            >
                <div className="container-fluid p-0">
                    {this.container && (
                        <InfiniteScroll
                            throttle={100}
                            threshold={300}
                            hasMore={hasMore}
                            isLoading={busy}
                            container={this.container}
                            onLoadMore={loadMoreAsync}
                        >
                            <div className="container-fluid pt-0">
                                <div className="row">
                                    <div className="col-xs-12 w-100">
                                        <table className="table table-striped">
                                            <DisplayHeader vm={this.vm} />
                                            <tbody>
                                                {displays.map((d, idx) => (
                                                    <DisplayRow
                                                        key={idx}
                                                        display={d}
                                                        vm={this.vm}
                                                        history={this.props.history}
                                                    />
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </InfiniteScroll>
                    )}
                    {busy && (
                        <div className="d-block w-100 text-center">
                            <BsArrowRepeat className=" d-block" />
                        </div>
                    )}
                </div>
            </Modal>
        );
    }

    @computed
    private get viewType() {
        if (this.appStore.isMobile) {
            return false;
        } else {
            return this.listView;
        }
    }

    @computed
    private get cardClass() {
        if (!this.listView) {
            return 'btn btn-primary toggle-card active disabled';
        } else {
            return 'btn btn-primary toggle-card';
        }
    }

    @computed
    private get listClass() {
        if (this.listView) {
            return 'btn btn-primary toggle-list active disabled';
        } else {
            return 'btn btn-primary toggle-list';
        }
    }

    @bind
    private onClear() {
        console.log('clear');
    }

    @bind
    @action
    private onChange(
        displayFilter: Mri.Web.Portal.Controllers.DisplayFilters.DisplayFilterModel,
        displayEventFilter: Mri.DisplayEvents.DisplayEventFilter,
        sort: string[],
        where: IWhereClause[],
        columns: IMultiSelectOption<string | Mri.WebApi.MeasurementId>[]
    ) {
        //this.accountStore.storage.displayTableColumns = columns;
        this.displayFiltersStore.storage.displayFilter = displayFilter;
        this.displayFiltersStore.storage.sort = sort;
        //this.displayFiltersStore.storage.where = where;

        //const query = stringify({
        //    displayFilter: JSON.stringify(displayFilter),
        //    sort: JSON.stringify(sort),
        //    where: JSON.stringify(where),
        //});
    }

    //Private Fields
    private renderTitle() {
        return (
            <span className="row text-header fw-bold w-100 justify-content-around">
                {this.props.accounts && this.props.accounts.length > 1 && (
                    <div className="d-none d-lg-block col-lg-4 small">
                        {this.props.accounts.map((a, idx) => (
                            <span key={idx}>
                                {idx == this.props.accounts!.length - 1 && <span>{a}</span>}
                                {idx != this.props.accounts!.length - 1 && <span>{a}, </span>}
                                {idx == 3 && <span>...</span>}
                                {idx >= 4 && <span />}
                            </span>
                        ))}
                    </div>
                )}

                {this.props.accounts && this.props.accounts.length <= 1 && (
                    <div className="d-none d-lg-block col-lg-4 small">
                        {this.props.accounts.map((a, idx) => (
                            <span key={idx}>{a}</span>
                        ))}
                    </div>
                )}

                {
                    //   !this.props.accounts && <div className="col-4">All Accounts</div>
                }

                {this.props.title && (
                    <div className="col-sm-12 col-lg-4 me-lg-auto text-center">
                        <h5>{this.props.title}</h5>
                    </div>
                )}

                {!this.props.title && (
                    <div className="col-2">
                        <BsTv /> {this.vm.total} Displays Showing
                    </div>
                )}
            </span>
        );
    }

    @observable
    private loading = false;

    @observable
    private listView: boolean;

    @observable
    private vm: DisplayListViewModel;
    private container: HTMLDivElement | null = null;
    @inject
    private displayFiltersStore!: DisplayFiltersStore;
    @inject
    private appStore!: AppStore;
}
